/**
 * Post-login return-URL plumbing. The invitation accept page stashes
 * its own URL in `sessionStorage` before redirecting to the login
 * flow; LoginPage (desktop branch) and AuthCallbackPage (web branch)
 * both call `consumePostLoginReturnUrl()` after a successful sign-in
 * and redirect there if a return URL was set.
 *
 * The allow-list pattern (must start with `/i/`) prevents an open
 * redirect — even if an attacker writes to sessionStorage on
 * another tab they can only redirect into invitation-accept routes,
 * which require a valid token to do anything interesting.
 */
const KEY = 'fluxter:post-login-return-url';

const ALLOWED_PREFIXES = ['/i/'];

export const stashPostLoginReturnUrl = (path: string): void => {
  if (typeof window === 'undefined') return;
  if (!ALLOWED_PREFIXES.some((p) => path.startsWith(p))) return;
  sessionStorage.setItem(KEY, path);
};

/** Read + clear in one call so a second invocation can't double-redirect. */
export const consumePostLoginReturnUrl = (): string | null => {
  if (typeof window === 'undefined') return null;
  const value = sessionStorage.getItem(KEY);
  if (!value) return null;
  sessionStorage.removeItem(KEY);
  if (!ALLOWED_PREFIXES.some((p) => value.startsWith(p))) return null;
  return value;
};
